<template>
  <div>
    Geo Tags
  </div>
</template>

<script>
// import messages from "../../modules/lang/export";
export default {
  // i18n: { messages },
  data(){
    return {

    }
  },
  computed: {
    
  }
}
</script>